export default __webpack_public_path__ + "static/media/product-06 (2).e0a741d7.jpg";